import {
  useDictionary,
  useIsDesktop,
  usePrescriptionAndUnHandledOrders,
} from 'Hooks';
import { ButtonActions } from './ButtonActions';
import { PrevPrescriptions } from './PrescriptionsAndPrevOrders';
import { RenewPrescriptionCollapse } from './RenewPrescriptionCollapse';
import { Title } from './Title';
import { NewUserInformation } from './NewUserInformation';
import { LinkArrowLeft2, Loader } from 'Components';
import { useState } from 'react';
import { LinkReturnToMain } from 'Components/LinkReturnToMain';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { RoutesConfig } from 'Routes';
import { Stack } from '@mui/material';

export const MedicationsAndPrescriptionsMain = () => {
  const { medications, STATUS, prescriptionsAndUnHandledOrders } =
    usePrescriptionAndUnHandledOrders();

  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.MedicationsAndPrescriptionsLobby
  );
  const isDesktop = useIsDesktop();

  const [displayNoValidMedications, setDisplayNoValidMedications] =
    useState<boolean>(false);

  const handleNoValidMedications = () => {
    setDisplayNoValidMedications(true);
  };

  if (STATUS !== 'FINISHED') {
    return <Loader />;
  }

  if (displayNoValidMedications) {
    return <NewUserInformation isNoValidrMedications={true} />;
  }

  if (
    STATUS === 'FINISHED' &&
    medications.length === 0 &&
    prescriptionsAndUnHandledOrders.prescriptions?.length === 0
  )
    return <NewUserInformation isNoValidrMedications={false} />;

  return (
    <Stack maxWidth={isDesktop ? '1125px' : 'initial'}>
      <LinkReturnToMain internal link='/' label={dictionary.returnToHome} />
      <Title />

      <ButtonActions handleNoValidMedications={handleNoValidMedications} />
      <LinkArrowLeft2
        text={dictionary.medHistory}
        href={RoutesConfig.MEDICATION_HISTORY.PATH}
        newWindow={false}
      />
      <RenewPrescriptionCollapse />
      {prescriptionsAndUnHandledOrders.prescriptions.length > 0 && (
        <PrevPrescriptions />
      )}
    </Stack>
  );
};
